export default function (route: string) {
    return new URL(route, document.location as any).href
}